import { colors } from '@globals/themes/defaultTheme'
import { tabletQuery } from '@globals/themes/themeConstants'
import { useOnboardingFabVisible } from '@globals/useOnboardingFabStore'
import { ACTION_BUTTONS_OFFSET } from '@layouts/standardPageLayout/ActionButtons'
import CloseFullscreenOutlinedIcon from '@mui/icons-material/CloseFullscreenOutlined'
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined'
import Fab from '@mui/material/Fab'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import { T } from '@transifex/react'
import { forwardRef, useEffect } from 'react'

const buttonStyle = {
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1000,
  color: colors.grayDark,
  backgroundColor: colors.white,
  '&:hover': {
    backgroundColor: colors.blueExtraLight,
  },
  '&:active': {
    backgroundColor: colors.blueExtraLight,
  },
  [tabletQuery]: {
    bottom: `${ACTION_BUTTONS_OFFSET}px`,
    right: 16,
  },
}

type OnboardingGuideFabProps = {
  onClick: () => void
  isDialogOpen: boolean
}

const OnboardingGuideFab = forwardRef<HTMLButtonElement, OnboardingGuideFabProps>(
  ({ onClick, isDialogOpen }, ref) => {
    const isTablet = useMediaQuery(tabletQuery)
    const { setOnboardingFabVisible } = useOnboardingFabVisible()

    useEffect(() => {
      setOnboardingFabVisible(true)
      return () => {
        setOnboardingFabVisible(false)
      }
    }, [setOnboardingFabVisible])

    return (
      <Fab
        id="onboarding-guide-fab" // used to reserve space for the FAB on mobile, do not change this ID
        ref={ref}
        color="primary"
        variant="extended"
        onClick={onClick}
        sx={buttonStyle}
        aria-label="Open onboarding guide">
        {isDialogOpen ? (
          <>
            <CloseFullscreenOutlinedIcon sx={{ mr: isTablet ? 0 : 1, color: colors.grayDark }} />
            {!isTablet && (
              <Typography>
                <T _str="Minimize setup guide" />
              </Typography>
            )}
          </>
        ) : (
          <>
            <OpenInFullOutlinedIcon sx={{ mr: isTablet ? 0 : 1, color: colors.grayDark }} />
            {!isTablet && (
              <Typography>
                <T _str="Expand setup guide" />
              </Typography>
            )}
          </>
        )}
      </Fab>
    )
  },
)

OnboardingGuideFab.displayName = 'OnboardingGuideFab'

export default OnboardingGuideFab
